import React from "react";
import { Phone } from "lucide-react";

export function sellerTelHref(phone) {
  const p = (phone || "").trim();
  if (!p) return null;
  return `tel:${p.replace(/[\s()-]/g, "")}`;
}

const phoneBtnClass = (compact) => (
  compact
    ? "inline-flex items-center gap-1 text-[11px] text-emerald-300 hover:text-emerald-200 font-medium"
    : "inline-flex items-center justify-center gap-2 py-3.5 rounded-full glass hover:bg-white/10 text-white font-medium transition-all w-full"
);

/** Nyilvános hirdetés — eladó telefon(ok) és opcionális e-mail. */
export function ListingSellerPhone({ car, testid, className = "", compact = false }) {
  const phone = (car?.seller_phone || "").trim();
  const phone2 = (car?.seller_phone_2 || "").trim();
  const href = sellerTelHref(phone);
  const href2 = sellerTelHref(phone2);
  const email = car?.show_email_public && (car?.public_email || "").trim();

  if (!href && !href2 && !email) return null;

  const wrap = className || (compact ? "flex flex-col gap-1" : "flex flex-col gap-2 w-full");

  return (
    <div className={wrap} data-testid={testid}>
      {href && (
        <a href={href} data-testid={`${testid}-primary`} onClick={(e) => e.stopPropagation()} className={phoneBtnClass(compact)}>
          <Phone className={compact ? "w-3 h-3 shrink-0" : "w-4 h-4 shrink-0"} strokeWidth={1.5} />
          {phone}
        </a>
      )}
      {href2 && (
        <a href={href2} data-testid={`${testid}-secondary`} onClick={(e) => e.stopPropagation()} className={phoneBtnClass(compact)}>
          <Phone className={compact ? "w-3 h-3 shrink-0" : "w-4 h-4 shrink-0"} strokeWidth={1.5} />
          {phone2}
        </a>
      )}
      {email && (
        <a
          href={`mailto:${email}`}
          data-testid={`${testid}-email`}
          onClick={(e) => e.stopPropagation()}
          className={phoneBtnClass(compact)}
        >
          {email}
        </a>
      )}
    </div>
  );
}
